/**
 * Console tracing for a screen's data path — development only, so it never
 * reaches a production bundle.
 */
export function debug(scope, data) {
  if (process.env.NODE_ENV === 'production') return;
  console.log(`%c${scope}`, 'color:#6d5efc;font-weight:600', data);
}
